import { render, staticRenderFns } from "./navigation-search.vue?vue&type=template&id=0534172a&"
import script from "./navigation-search.vue?vue&type=script&lang=ts&"
export * from "./navigation-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports